<form  [formGroup]="form" *ngIf="form && movementPlan?.boat" (submit)="next()">
  <section class="container">
        <div class="card" *ngIf="form.get('navigationPlan')" formGroupName="navigationPlan">
      <div class="header">
        <img class="user-location-icon" src="/assets/icons/user-location.svg" alt="">
        <b class="user-location-icon-text">Destino e Passageiros</b>
      </div>

      <div class="content">
        <div class="date-exit">
          <div class=" align-itens">

            <div class="form-control">
              <label>{{ hasChild ? 'Adultos' : 'Passageiros' }}</label>
              <app-passengers formControlName="crewQty" [typePeople]="hasChild ? 'Adult' : 'Person'" [totalPassengers]="totalPassagers - form.value.navigationPlan.childQty"></app-passengers>
            </div>

            <div class="form-control" *ngIf="hasChild">
              <label>{{ 'Crianças' }}</label>
              <app-passengers formControlName="childQty" [typePeople]="'Child'" [totalPassengers]="totalPassagers - form.value.navigationPlan.crewQty"></app-passengers>
            </div>

            <app-destinies-navigation-plan-mv class="width-destination"
              formControlName="destination"
              [frequentDestinations]="frequentDestinations">
            </app-destinies-navigation-plan-mv>

          </div>
        </div>
      </div>
    </div>
    <div *ngIf="getFirstEdit()"  class="card">
      <div class="header" style="padding-top: 45px;">
        <img class="align-icon-saida-retorno" src="/assets/images/Arrow-right.png" alt="">
        <img *ngIf="this.movementPlan.objectiveCode !== 'SINGLE' && getLastEdit()" class="align-icon-saida-retorno" src="/assets/images/Arrow-left.png" alt="">
        <b class="align-title-icon">Saída<span *ngIf="this.movementPlan.objectiveCode !== 'SINGLE' && getLastEdit()"> e</span></b>
        <b *ngIf="this.movementPlan.objectiveCode !== 'SINGLE' && getLastEdit()">Retorno</b>
      </div>

      <div class="content">
        <div class="date-exit">
          <app-schedule-date-mv
            formControlName="executionDate"
            [minDate]="minDateToExecutionDate"
            [boat]="movementPlan.boat"
            [title]="'Saída'"
            [started]="isAlreadyStarted() || lockExecutionDate"
            (dateTimeSelected)="onDepartureDateTimeSelected($event)">
          </app-schedule-date-mv>
          <app-schedule-date-mv
          *ngIf="this.movementPlan.objectiveCode !== 'SINGLE' && getLastEdit()"
            formControlName="returnTime"
            [isReturnDate]="true"
            [minDate]="getReturnMinDate()"
            [boat]="movementPlan.boat"
            [title]="'Retorno'"
            [started]="isAlreadyStarted()">
          </app-schedule-date-mv>
          <app-messages *ngIf="form && form.errors?.returnTimeNotBeforeExecutionError"
            [link]=""
            [titleMessage]="' Datas inválidas '"
            [textMessage]="' A data de retorno deve ser maior que a data de saída. '"
            [msgAction]="''">
          </app-messages>
        </div>
      </div>
    </div>

   

        <div  class="card" >
      <div class="header">
        <i class="table-icon pi pi-comment" style="font-size: 2rem; margin-bottom: 8px;"></i>
        <b class="align-title-icon">Observações</b>
      </div>
      <div class="observation-container">
        <textarea 
          class="observation-input"
          name="messageNavigationPlan"
          formControlName="observation" 
          placeholder="Dígite as observações"></textarea>
      </div>
    </div>
  </section>

  <div class="buttons align-bottom">
    <!-- <div [ngClass]="{'align-bottom': !form.value.navigationPlan}" class="buttons"> -->
    <button class="easymarine" *ngIf="isNew" (click)="back()" type="button">{{'BACK'| translate}}</button>
    <button class="easymarine danger" (click)="cancel()" type="button">{{'CANCEL'| translate}}</button>
    <button class="easymarine primary" type="submit" [disabled]="!form.valid">{{'SAVE'| translate}}</button>
  </div>
</form>
